<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add new {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.name"
              v-model="site.name"
              :label="$globalConfig.APP_NAME === 'senso' ? 'Site Name' : 'Location Name'"
              type="text"
              filled
              class="input-width"
            >
            </v-text-field>

          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="add-course-button" @click="addSite">Add {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location' }}</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import companyAPI from "@/api/company.js";
export default {
  name: "AddSite",
  props: {
    params: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      site: {name:''},
      messages: {},
      loading: false,
      successMessage: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'} Successfully Added.`,
      errorMessage:
        "Oops, something went wrong! Please check information is correct."
    };
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addSite() {
      this.loading = true;
      companyAPI
        .createSite(this.site)
        .then(() => {
          this.closePanel();
          EventBus.$emit("SITES_UPDATED");
          this.$snotify.success(this.successMessage);
          this.loading = false;
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
        });
    }
  }
};
</script>
